import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Title from "../../components/title";
import "./paymentData.css";
import { faBagShopping } from "@fortawesome/free-solid-svg-icons";

import TableComponent from "../../components/TableComponent";
import { useNavigate } from "react-router";

function LoansData() {
  const columns = [
    { name: "رقم القرض", key: "serial" },
    { name: "إسم المستفيد", key: "hcname" },
    { name: "قيمة القرض", key: "amount" },
    { name: "تاريخ منح القرض", key: "responsedate" },
    { name: "الأولوية", key: "priority" },
    { name: "حالة القرض", key: "status_string" },
    { name: "عدد شهور القرض", key: "loancount" },
    { name: "", key: "actions" },
  ];
  const navigate = useNavigate();

  const dropdownOptions = [
    {
      label: "عرض المدفوعات",
      action: (id, record) => {
        if (record.status !== 1) {
          alert("لا يمكن عرض المدفوعات حتى تتم الموافقة على القرض");
        } else {
          navigate(`/paymentdata/${id}`);
        }
      },
    },
    { label: "دراسة الجدوى", action: (id , record) => {
      if(record.feasibility !== null){
        alert("تم إنشاء دراسة جدوى لهذا القرض مسبقاً");
      }else{ 
        navigate(`/feasibilitystudy/${id}`);
      }
    } },
    { label: "عرض القرض", route: "/loandetails/:id" },
  ];

  const modifyRow = (row) => {
    let newRow = { ...row };
    newRow.amount = Intl.NumberFormat().format(row.amount);
    newRow.priority = row.priority == 1 ? "قصوى" : "عادي";
    return newRow;
  };
  return (
    <>
      <Title
        title="بيانات القروض"
        icon={<FontAwesomeIcon icon={faBagShopping} />}
      />
      <div className="paymentdata">
        <TableComponent
          apiUrl={"/loans"}
          columns={columns}
          dropdownOptions={dropdownOptions}
          transformRowFn={modifyRow}
        />
      </div>
    </>
  );
}

export default LoansData;
